import { render, staticRenderFns } from "./AppDashboardBar.vue?vue&type=template&id=36b50bec&"
import script from "./AppDashboardBar.vue?vue&type=script&lang=js&"
export * from "./AppDashboardBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports